import { FC } from "react";

import Loading from "src/components/DataStates/Loading.tsx";
import { PassiveModal } from "src/components/Modal";
import WidgetRenderer from "src/dynamic-view-renderer/Widgets/WidgetRenderer.tsx";
import { mapToModalError } from "src/errors";
import { useGetAlertById } from "src/graphql/anti-fraud/queries/alerts/GetAlertByIdQuery.ts";
import { useT } from "src/internationalization";
import { AlertSummary } from "src/types/alert";

export type AlertScoreDetailsModalProps = {
  alert: AlertSummary;
  onClose: () => void;
};

export const AlertScoreDetailsModal: FC<AlertScoreDetailsModalProps> = ({ alert, onClose }) => {
  const t = useT();
  const { data, error, loading } = useGetAlertById({ id: alert.id });

  return (
    <PassiveModal
      onClose={onClose}
      title={t("page.alerts.modal.score.title")}
      loading={false}
      error={error ? mapToModalError(error) : undefined}
    >
      {loading ? (
        <Loading />
      ) : (
        <WidgetRenderer
          data={{
            widgetsData: {
              rules: { scenarioExecutionResult: data?.scenarioExecutionResult },
            },
          }}
          rowConfiguration={{ widgets: [{ widgetCode: "rules" }] }}
          widgetConfig={{ widgetCode: "rules" }}
        />
      )}
    </PassiveModal>
  );
};
